// removed by extract-text-webpack-plugin
module.exports = {"ndaBtns":"ndaBtns"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UploadInventory/UploadInventory.scss
// module id = 5328
// module chunks = 1